/**
 * Cart Offer Progress Bar
 * Tracks eligible posters (tagged "single-poster") toward discount thresholds
 * Updates via Rebuy cart events
 */

(function() {
  'use strict';

  const ELIGIBLE_TAG = 'single-poster';

  /* Push the progress bar html to the Rebuy cart drawer */
  function injectProgressBarIntoRebuyCart() {
    const originalProgressBar = document.querySelector('.cart-offer-progress');
    const settings = window.PXUTheme?.theme_settings;
  
    if (!originalProgressBar || !settings) {
      return;
    }

    // Log product tags from Rebuy cart items
    const cartItems = Rebuy.SmartCart.items();
    
    // Find the Rebuy cart container - try multiple selectors
    const rebuyCartFlyout = document.querySelector('.rebuy-cart__flyout');
    const rebuyFooterAnchor = document.querySelector('[data-rebuy-cart-anchor="footer"]');
    
    if (!rebuyCartFlyout && !rebuyFooterAnchor) {
      console.log('Rebuy cart not found');
      return;
    }

    // Find or create the progress bar in Rebuy cart
    let rebuyProgressBarElement = rebuyFooterAnchor?.parentElement?.querySelector('.cart-offer-progress') || rebuyCartFlyout?.querySelector('.cart-offer-progress');
    
    if (!rebuyProgressBarElement && rebuyFooterAnchor) {
      const clonedProgressBar = originalProgressBar.cloneNode(true);
      rebuyFooterAnchor.parentElement.insertBefore(clonedProgressBar, rebuyFooterAnchor);
      rebuyProgressBarElement = clonedProgressBar;
    } else if (rebuyProgressBarElement) {
      console.log('Found existing progress bar in Rebuy cart');
    }
    
    if (!rebuyProgressBarElement) {
      console.error('Could not find or create progress bar in Rebuy cart');
      return;
    }

    // Count eligible items (products with "single-poster" tag) from Rebuy cart
    let eligibleCount = 0;
    cartItems.forEach(item => {
      const tags = item.product?.tags;      
      
      let tagsArray = [];
      if (Array.isArray(tags)) {
        tagsArray = tags;
      } else if (typeof tags === 'string') {
        tagsArray = tags.split(',').map(tag => tag.trim());
      }
      
      // Check if the tag matches "single-poster" (case-insensitive, exact match)
      const hasTag = tagsArray.some(tag => 
        tag.toLowerCase().trim() === ELIGIBLE_TAG.toLowerCase()
      );
      
      if (hasTag) {
        eligibleCount += item.quantity || 1;
      }
    });

    const activeTiers = settings.cart_offer_active_tiers || 0;
    updateRebuyProgressBar(rebuyProgressBarElement, eligibleCount, settings, activeTiers);
  }

  /* Update the progress bar visual state in Rebuy cart */
  function updateRebuyProgressBar(progressElement, eligibleCount, settings, activeTiers) {
    if (!progressElement) {
      console.error('Progress bar element not found');
      return;
    }

    const labelElement = progressElement.querySelector('.cart-offer-progress__label');
    if (labelElement) {
      let labelText = '';
      
      // Calculate values for variable replacement
      const totalNeeded = activeTiers + 1;
      const remainingAmount = totalNeeded - eligibleCount;
      const cartOfferValue = settings.cart_offer_value || '';
      
      // 0 items = no label
      if (eligibleCount === 0) {
        labelText = '';
      }
      // Reached maximum - show reached label when count exceeds active tiers
      else if (eligibleCount > activeTiers) {
        labelText = settings.cart_offer_reached_label || '';
      }
      else {
        // Map: 1 item -> tier_label_1, 2 items -> tier_label_2, 3 items -> tier_label_3, 4 items -> tier_label_4
        if (eligibleCount === 1) {
          labelText = settings.cart_offer_tier_label_1 || '';
        } else if (eligibleCount === 2) {
          labelText = settings.cart_offer_tier_label_2 || '';
        } else if (eligibleCount === 3) {
          labelText = settings.cart_offer_tier_label_3 || '';
        } else if (eligibleCount === 4) {
          labelText = settings.cart_offer_tier_label_4 || '';
        }
      }
      
      // Replace variables: {remaining_amount} -> number, {cart_offer_value} -> value
      if (labelText) {
        labelText = labelText.replace(/\{remaining_amount\}/gi, String(remainingAmount)).replace(/\{(\d+)\}/g, '$1');
        labelText = labelText.replace(/\{cart_offer_value\}/gi, cartOfferValue).replace(/\{(\d+)\}/g, '$1');
      }
      
      labelElement.textContent = labelText;
    } else {
      console.error('Label element not found in progress bar');
    }

    // Update progress bar dots and fill line
    const tiersContainer = progressElement.querySelector('.cart-offer-progress__tiers');
    if (!tiersContainer) {
      console.error('Tiers container not found in progress bar');
      return;
    }

    const tiers = tiersContainer.querySelectorAll('.cart-offer-progress__tier');
    const totalTiers = tiers.length;
        
    // Calculate how many dots should be active
    const activeDots = eligibleCount > activeTiers ? totalTiers : Math.min(eligibleCount, activeTiers);
        
    // Update tier active states and calculate fill percentage in one pass
    const fillPercentage = eligibleCount === 0 ? 0 : (activeDots / totalTiers) * 100;

    tiers.forEach((tier, index) => {
      if (index < activeDots) {
        tier.classList.add('active');
      } else {
        tier.classList.remove('active');
      }
    });

    // Update CSS variable for the fill line
    tiersContainer.style.setProperty('--tiers-completed-pct', fillPercentage + '%');
  }
  

  document.addEventListener("rebuy:smartcart.ready", (event) => {
    setTimeout(() => {
      injectProgressBarIntoRebuyCart();
    }, 500);
  });

  document.addEventListener("rebuy:cart.change", (event) => {
    setTimeout(() => {
      injectProgressBarIntoRebuyCart();
    }, 500);
  });

  document.addEventListener("rebuy:cart.add", () => {
    setTimeout(() => {
      injectProgressBarIntoRebuyCart();
    }, 500);
  });

  document.addEventListener("rebuy:smartcart.product-added", () => {
    setTimeout(() => {
      injectProgressBarIntoRebuyCart();
    }, 500);
  
});

})();